<template>
  <b-overlay
    :show="loading"
    rounded="sm"
  >
    <b-row>
      <b-col>
        <b-card title="اطلاعات اصلی">
          <b-row>
            <b-col md="4">
              <b-form-group
                label="عنوان گمرک"
                label-for="Title"
              >
                <b-form-input
                  v-model="Form.Title"
                  autocomplete="off"
                />
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group
                label="شهر"
                label-for="CityId"
              >
                <z-city v-model="Form.CityId" />
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group
                label="وضعیت"
                label-for="IsActive"
              >
                <v-select
                  v-model="Form.IsActive"
                  :options="enums('IsActive')"
                  dir="rtl"
                  label="text"
                  :reduce="x => x.value"
                  :clearable="false"
                />
              </b-form-group>
            </b-col>

            <b-col md="8">
              <b-form-group
                label="نوع گمرک"
                label-for="Type"
              >
                <z-customs-type
                  v-model="Form.Type"
                  :multiple="true"
                />
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group
                label="مرز مشترک با کشور"
                label-for="BorderCountryId"
              >
                <z-country
                  v-model="Form.BorderCountryId"
                  :clearable="true"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>

        <b-card title="اطلاعات تماس">
          <b-row>
            <b-col md="12">
              <b-form-group
                label="آدرس دقیق"
                label-for="Address"
              >
                <b-form-input
                  v-model="Form.Address"
                  autocomplete="off"
                />
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group
                label="تلفن"
                label-for="Phone"
              >
                <b-form-input
                  v-model="Form.Phone"
                  autocomplete="off"
                />
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group
                label="کد پستی"
                label-for="PostalCode"
              >
                <b-form-input
                  v-model="Form.PostalCode"
                  autocomplete="off"
                />
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group
                label="کد گمرک"
                label-for="Code"
              >
                <b-form-input
                  v-model="Form.Code"
                  autocomplete="off"
                />
              </b-form-group>
            </b-col>

            <!-- <b-col md="4">
              <b-form-group
                label="ساعات کاری"
                label-for="WorkingHours"
              >
                <b-form-input
                  v-model="Form.WorkingHours"
                  autocomplete="off"
                />
              </b-form-group>
            </b-col> -->
          </b-row>
        </b-card>

        <b-card title="موقعیت روی نقشه">
          <b-row>
            <b-col
              md="8"
              class="mb-1 mb-md-0"
            >
              <z-location-picker
                :latitude.sync="Form.Latitude"
                :longitude.sync="Form.Longitude"
              />
            </b-col>

            <b-col
              md="4"
              class="d-flex flex-column justify-content-center"
            >
              <b-form-group
                label="عرض جغرافیایی (Latitude)"
                label-for="Latitude"
              >
                <b-input-group>
                  <b-input-group-prepend is-text>
                    <feather-icon icon="MapPinIcon" />
                  </b-input-group-prepend>
                  <b-form-input
                    id="Latitude"
                    v-model.number="Form.Latitude"
                    placeholder="مثلاً 35.6892"
                    autocomplete="off"
                  />
                </b-input-group>
              </b-form-group>

              <b-form-group
                label="طول جغرافیایی (Longitude)"
                label-for="Longitude"
              >
                <b-input-group>
                  <b-input-group-prepend is-text>
                    <feather-icon icon="NavigationIcon" />
                  </b-input-group-prepend>
                  <b-form-input
                    id="Longitude"
                    v-model.number="Form.Longitude"
                    placeholder="مثلاً 51.3890"
                    autocomplete="off"
                  />
                </b-input-group>
              </b-form-group>

              <b-button
                v-if="Form.Latitude || Form.Longitude"
                variant="flat-danger"
                size="sm"
                class="align-self-start"
                @click="clearLocation"
              >
                <feather-icon
                  icon="XIcon"
                  size="14"
                  class="mr-25"
                />
                حذف موقعیت
              </b-button>
            </b-col>
          </b-row>
        </b-card>

        <b-card title="کالاهای گمرکی">
          <b-row>
            <b-col md="6">
              <b-form-group
                label="کالاهای گمرکی واردات"
                label-for="ImportGoodId"
              >
                <z-customs-good
                  v-model="Form.ImportGoodId"
                  :multiple="true"
                />
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group
                label="کالاهای گمرکی صادرات"
                label-for="ExportGoodId"
              >
                <z-customs-good
                  v-model="Form.ExportGoodId"
                  :multiple="true"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>

        <b-card title="رویه های گمرکی">
          <b-row>
            <b-col md="6">
              <b-form-group
                label="رویه های گمرکی"
                label-for="GomrokiProcedureId"
              >
                <z-customs-procedure
                  v-model="Form.GomrokiProcedureId"
                  :multiple="true"
                />
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group
                label="کارنه تیر"
                label-for="TirCarnetId"
              >
                <z-tir-carnet
                  v-model="Form.TirCarnetId"
                  :multiple="true"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>

        <!-- <b-card title="ترخیص کاران فعال">
          <b-row>
            <b-col
              v-for="(agent, index) in Form.AgentUserId"
              :key="index"
              md="4"
              class="d-flex align-items-center mb-1"
            >
              <z-user
                :value="agent"
                :clearable="true"
                class="flex-grow-1"
                @input="v => setAgent(index, v)"
              />
              <feather-icon
                icon="TrashIcon"
                size="18"
                class="ml-1 cursor-pointer text-danger"
                @click="Form.AgentUserId.splice(index, 1)"
              />
            </b-col>

            <b-col md="12">
              <b-button
                variant="outline-primary"
                size="sm"
                @click="Form.AgentUserId.push(null)"
              >
                افزودن ترخیص کار
              </b-button>
            </b-col>
          </b-row>
        </b-card> -->

        <b-card title="گالری تصاویر">
          <b-row>
            <b-col
              v-for="image in Form.Image"
              :key="`old-${image.Id}`"
              cols="6"
              md="2"
              class="mb-1"
            >
              <div class="customs-gallery-item">
                <img :src="image.Image">
                <feather-icon
                  icon="XIcon"
                  size="18"
                  class="customs-gallery-remove"
                  @click="removeImage(image)"
                />
              </div>
            </b-col>

            <b-col
              v-for="(item, index) in newImages"
              :key="`new-${index}`"
              cols="6"
              md="2"
              class="mb-1"
            >
              <div class="customs-gallery-item">
                <img :src="item.preview">
                <feather-icon
                  icon="XIcon"
                  size="18"
                  class="customs-gallery-remove"
                  @click="removeNewImage(index)"
                />
              </div>
            </b-col>

            <b-col
              cols="6"
              md="2"
              class="mb-1"
            >
              <div
                class="customs-gallery-add"
                @click="$refs.imageInput.click()"
              >
                <feather-icon
                  icon="PlusIcon"
                  size="28"
                />
                <span class="mt-50">افزودن تصویر</span>
              </div>
              <input
                ref="imageInput"
                type="file"
                multiple
                accept="image/*"
                class="d-none"
                @change="onFilesSelected"
              >
            </b-col>
          </b-row>
        </b-card>

        <b-card title="توضیحات و ملاحظات">
          <b-row>
            <b-col md="12">
              <b-form-group
                label="توضیحات"
                label-for="Description"
              >
                <z-quill-editor v-model="Form.Description" />
              </b-form-group>
            </b-col>

            <!-- <b-col md="12">
              <b-form-group
                label="ملاحظات"
                label-for="Note"
              >
                <b-form-textarea
                  v-model="Form.Note"
                  rows="3"
                  no-resize
                  disabled="true"
                />
              </b-form-group>
            </b-col> -->

            <b-col cols="12">
              <hr>
            </b-col>
            <b-col class="mt-1 mb-1 text-center">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mr-1"
                @click="save"
              >
                ذخیره
              </b-button>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                variant="outline-secondary"
                @click="back"
              >
                بازگشت
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>

import ZCity from '@/tools/city.vue'
import ZCountry from '@/tools/country.vue'
import ZCustomsGood from '@/tools/customs/customsgood.vue'
import ZCustomsProcedure from '@/tools/customs/customsprocedure.vue'
import ZCustomsType from '@/tools/customs/customstype.vue'
import ZTirCarnet from '@/tools/customs/tircarnet.vue'
import ZUser from '@/tools/user.vue'
import ZQuillEditor from '@/tools/quilleditor.vue'
import ZLocationPicker from '@/tools/locationpicker.vue'

export default {
  name: 'CustomsDetails',
  components: {
    ZCity, ZCountry, ZCustomsGood, ZCustomsProcedure, ZCustomsType, ZTirCarnet, ZUser, ZQuillEditor, ZLocationPicker,
  },
  data() {
    return {
      loading: false,
      newImages: [],
      procedures: [],
      Form: {
        Id: null,
        Title: null,
        CityId: null,
        IsActive: true,
        BorderCountryId: null,
        Address: null,
        Phone: null,
        PostalCode: null,
        Code: null,
        WorkingHours: null,
        Latitude: null,
        Longitude: null,
        Description: null,
        Note: null,
        Type: [],
        ImportGoodId: [],
        ExportGoodId: [],
        GomrokiProcedureId: [],
        TransitProcedureId: [],
        TirCarnetId: [],
        AgentUserId: [],
        Image: [],
        RemovedImageId: [],
      },
    }
  },
  created() {
    this.loadProcedures().finally(() => {
      if (this.$route.params.id) {
        this.Form.Id = this.$route.params.id
        this.get()
      }
    })
  },
  beforeDestroy() {
    this.newImages.forEach(item => URL.revokeObjectURL(item.preview))
  },
  methods: {
    loadProcedures() {
      return this.$http.post(
        this.$api.customsprocedure.getall, {},
      )
        .then(res => {
          this.procedures = res.data
        })
    },
    setAgent(index, value) {
      this.$set(this.Form.AgentUserId, index, value)
    },
    clearLocation() {
      this.Form.Latitude = null
      this.Form.Longitude = null
    },
    removeImage(image) {
      this.Form.RemovedImageId.push(image.Id)
      this.Form.Image = this.Form.Image.filter(x => x.Id !== image.Id)
    },
    onFilesSelected(e) {
      const files = Array.from(e.target.files || [])
      files.forEach(file => {
        this.newImages.push({ file, preview: URL.createObjectURL(file) })
      })
      e.target.value = null
    },
    removeNewImage(index) {
      URL.revokeObjectURL(this.newImages[index].preview)
      this.newImages.splice(index, 1)
    },
    get() {
      this.loading = true
      this.$http.post(
        this.$api.customs.get, {
          Id: this.Form.Id,
        },
      )
        .then(res => {
          const d = res.data

          this.Form.Id = d.Id
          this.Form.Title = d.Title
          this.Form.CityId = d.City ? d.City.Id : null
          this.Form.IsActive = d.IsActive
          this.Form.BorderCountryId = d.BorderCountry ? d.BorderCountry.Id : null
          this.Form.Address = d.Address
          this.Form.Phone = d.Phone
          this.Form.PostalCode = d.PostalCode
          this.Form.Code = d.Code
          this.Form.WorkingHours = d.WorkingHours
          this.Form.Latitude = d.Latitude
          this.Form.Longitude = d.Longitude
          this.Form.Description = d.Description
          this.Form.Note = d.Note
          this.Form.Type = d.Type || []
          this.Form.Image = d.Image || []
          this.Form.RemovedImageId = []

          this.Form.ImportGoodId = (d.ImportGood || []).map(x => x.CustomsGoodId)
          this.Form.ExportGoodId = (d.ExportGood || []).map(x => x.CustomsGoodId)

          const procedureIds = d.CustomsProcedureId || []
          const transitIds = this.procedures.filter(x => x.IsTransit).map(x => x.Id)
          this.Form.TransitProcedureId = procedureIds.filter(x => transitIds.includes(x))
          this.Form.GomrokiProcedureId = procedureIds.filter(x => transitIds.includes(x) === false)

          this.Form.TirCarnetId = d.TirCarnetId || []

          this.Form.AgentUserId = (d.Agent || []).map(x => x.UserId)
        })
        .finally(() => {
          this.loading = false
        })
    },
    save() {
      let url = this.$api.customs.add
      if (this.$route.params.id) {
        url = this.$api.customs.update
      }

      const formData = new FormData()

      if (this.Form.Id) {
        formData.append('Id', this.Form.Id)
      }

      formData.append('IsActive', this.Form.IsActive)

      const fields = ['Title', 'CityId', 'BorderCountryId', 'Address', 'Phone', 'PostalCode', 'Code', 'WorkingHours', 'Latitude', 'Longitude', 'Description', 'Note']
      fields.forEach(key => {
        if (this.Form[key] !== null && this.Form[key] !== undefined && this.Form[key] !== '') {
          formData.append(key, this.Form[key])
        }
      })

      this.Form.Type.forEach(item => {
        formData.append('Type', item)
      })

      let goodIndex = 0
      this.Form.ImportGoodId.forEach(item => {
        formData.append(`Goods[${goodIndex}].CustomsGoodId`, item)
        formData.append(`Goods[${goodIndex}].IsExport`, false)
        goodIndex += 1
      })
      this.Form.ExportGoodId.forEach(item => {
        formData.append(`Goods[${goodIndex}].CustomsGoodId`, item)
        formData.append(`Goods[${goodIndex}].IsExport`, true)
        goodIndex += 1
      });

      [...this.Form.GomrokiProcedureId, ...this.Form.TransitProcedureId].forEach(item => {
        formData.append('CustomsProcedureId', item)
      })

      this.Form.TirCarnetId.forEach(item => {
        formData.append('TirCarnetId', item)
      })

      this.Form.AgentUserId.filter(x => x).forEach(item => {
        formData.append('AgentUserId', item)
      })

      this.Form.RemovedImageId.forEach(item => {
        formData.append('RemovedImageId', item)
      })

      this.newImages.forEach(item => {
        formData.append('Image', item.file)
      })

      this.loading = true
      this.$http.post(
        url, formData,
      )
        .then(() => {
          this.back()
        })
        .finally(() => {
          this.loading = false
        })
    },
    back() {
      this.$router.push({ name: 'customs' })
    },
  },
}
</script>

<style scoped>
.customs-gallery-item {
  position: relative;
  border: 1px solid #dbdade;
  border-radius: 0.357rem;
  overflow: hidden;
  height: 90px;
}
.customs-gallery-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.customs-gallery-remove {
  position: absolute;
  top: 4px;
  right: 4px;
  background: rgba(255, 255, 255, 0.85);
  border-radius: 50%;
  padding: 2px;
  cursor: pointer;
  color: #ea5455;
}
.customs-gallery-add {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px dashed #dbdade;
  border-radius: 0.357rem;
  height: 90px;
  cursor: pointer;
  color: #6e6b7b;
  font-size: 0.8rem;
  transition: border-color 0.15s ease, color 0.15s ease;
}
.customs-gallery-add:hover {
  border-color: #7367f0;
  color: #7367f0;
}
</style>
